"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comment = exports.CommentDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_link_1 = require("./entity-link");
var tiny_relative_date_1 = __importDefault(require("tiny-relative-date"));
var content_node_1 = require("./content-node");
var person_photo_1 = require("./person-photo");
var icon_button_1 = require("../elements/icon-button");
var use_lang_1 = require("../../hooks/use-lang");
exports.CommentDefaultProps = {
  isReply: false,
  showEditControls: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
var AvatarStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "])), theme_1.theme.UNIT(3))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject([" \n    flex-grow: 1;\n    margin: 0;\n  "], [" \n    flex-grow: 1;\n    margin: 0;\n  "])))
});
var CreatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "])), theme_1.theme.COLOR('text'))
});
var SourceItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    white-space: nowrap;\n    margin-left: ", ";\n  "], ["\n    white-space: nowrap;\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.COLOR('text-subtle'), theme_1.theme.UNIT(2))
});
var WhenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    \n    ", ";\n  "], ["\n    color: ", ";\n    \n    ", ";\n  "])), theme_1.theme.COLOR('text-subtle'), SourceItemStyles)
});
var OrganisationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "], ["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "])), theme_1.theme.COLOR("text-subtle"), SourceItemStyles),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: inline-block;\n  "], ["\n    display: inline-block;\n  "])))
});
var SourceStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "], ["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "])), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n  "], ["\n    margin: 0 0 ", " 0;\n  "])), theme_1.theme.UNIT(1.5))
});
var CommentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    line-height: 1.5em;\n\n    p {\n      margin-top: 0; \n    }\n  "], ["\n    line-height: 1.5em;\n\n    p {\n      margin-top: 0; \n    }\n  "])))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    text-transform: none;\n    font-size: 1em;\n  "], ["\n    text-transform: none;\n    font-size: 1em;\n  "])))
});
var EditButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), SourceItemStyles, ButtonStyles)
});
var DeleteButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    ", ";\n    ", ";\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), SourceItemStyles, ButtonStyles, theme_1.theme.COLOR('text-subtle'), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    &:before {\n      margin-right: ", ";\n    }\n  "], ["\n    &:before {\n      margin-right: ", ";\n    }\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Avatar: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), AvatarStyles),
  Body: styled_components_1.default.article(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Source: styled_components_1.default.header(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), SourceStyles),
  Organisation: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Creator: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  When: styled_components_1.default.time(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), WhenStyles),
  EditButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), EditButtonStyles),
  DeleteButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), DeleteButtonStyles),
  Comment: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles)
};
var Comment = function (props) {
  var className = props.className,
    entity = props.entity,
    isReply = props.isReply,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    canDelete = props.canDelete,
    canEdit = props.canEdit,
    showEditControls = props.showEditControls;
  var avatarSize = isReply ? 36 : 48;
  var t = (0, use_lang_1.useLang)();
  var createdBy = entity.createdBy,
    created = entity.created,
    description = entity.description,
    isWriteable = entity.isWriteable;
  var organisation = createdBy.organisation;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Avatar, {
    size: avatarSize,
    link: true,
    entity: createdBy
  }), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Source, null, react_1.default.createElement(My.Creator, {
    entity: createdBy
  }), organisation && react_1.default.createElement(My.Organisation, {
    entity: organisation
  }), react_1.default.createElement(My.When, {
    datetime: created
  }, (0, tiny_relative_date_1.default)(created)), showEditControls && isWriteable && canEdit && react_1.default.createElement(My.EditButton, {
    onClick: onEdit,
    iconSize: 12,
    gap: "0px"
  }, t('Edit')), showEditControls && isWriteable && canDelete && react_1.default.createElement(My.DeleteButton, {
    onClick: onDelete,
    iconSize: 12,
    gap: "0px"
  }, t('Delete'))), react_1.default.createElement(My.Comment, {
    showEmbeds: true,
    entityTypeNameEmbedExclusions: ["Person", "Team"],
    entity: description
  })));
};
exports.Comment = Comment;
exports.Comment.defaultProps = exports.CommentDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;